import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class CaseBlockSelect extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filterString: "",
      selectedTitle: "",
    }
  }


  render() {
    const { classes, theme } = this.props;

    return (
      <div className={classes.root}>
        <InputLabel htmlFor="select-multiple-chip" style={{ marginRight: 10 }}>{this.props.label}</InputLabel>
        <Select
          value={this.props.selectedData}
          onChange={(e) => {
            this.props.onSelectedData(this.props.filterId, e.target.value)
          }}
          input={<Input id="select-multiple-chip" />}
          renderValue={selected => {
            for (let item of this.props.filterData) {
              if (item.value === selected) {
                return (
                  <div className={classes.chips}>
                    <Chip label={item.label} className={classes.chip} />
                  </div>
                )
              }
            }
          }}
          MenuProps={MenuProps}
        >
          <div style={{ width: '100%', position: "sticky", top: 0, left: 0, backgroundColor: 'white', zIndex: 15 }}>
            <Input fullWidth placeholder='Search Options' value={this.state.filterString} onChange={(e) => { this.setState({ filterString: e.target.value }) }} />
          </div>
          {this.props.filterData.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase())).filter(e => {
            const regex = new RegExp(`.*${this.state.filterString}.*`, 'i');
            return regex.test(e.label)
          }).map((obj) => {
            return (
              <MenuItem
                key={obj.label}
                value={obj.value}
              >
                {obj.label}
              </MenuItem>
            )
          })}
        </Select>
      </div>
    );
  }
}

CaseBlockSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(CaseBlockSelect);



// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/components/dragAndDrop/components/caseBlockSelect.jsx